export default {
  status: {},
  createdCampaignId: '',
};